import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Admin'
        },
        children: [
            {
                path: '',
                redirectTo: 'svs',
                pathMatch: 'full'
            },
            {
              path: 'svs',
              loadChildren: () => import('./svs/svs.module').then(m => m.SvsModule)
            },
            {
                path: 'wifi',
                loadChildren: () => import('./wifi/wifi.module').then(m => m.WifiModule)
            },
            {
                path: 'admin',
                loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule { }
